import { v4 as uuidv4 } from 'uuid';

export function ConditionLayoutProduct(props = {}, childrenComponents = []) {
	return {
		componentName: 'ConditionLayoutProduct',
		componentId: uuidv4(),
		props: Object.assign(
			{
				mzShowThen: true,
				conditions: [
					{
						subject: 'isProductAvailable',
					},
				],
				Then: null,
				Else: null,
			},
			props,
		),
		childrenComponents,
	};
}
